type TimeoutHandle = ReturnType<typeof setTimeout>;

export function wait(ms: number, signal?: AbortSignal): Promise<void> {
  return new Promise<void>((resolve) => {
    if (signal?.aborted) {
      resolve();
      return;
    }

    const onAbort = () => {
      clearTimeout(timeoutId);
      signal?.removeEventListener('abort', onAbort);
      resolve();
    };

    const timeoutId = setTimeout(() => {
      signal?.removeEventListener('abort', onAbort);
      resolve();
    }, ms);

    signal?.addEventListener('abort', onAbort);
  });
}

export function createChildAbortController(parentSignal: AbortSignal) {
  const controller = new AbortController();
  const propagateAbort = () => controller.abort();
  parentSignal.addEventListener('abort', propagateAbort);

  return {
    controller,
    dispose: () => parentSignal.removeEventListener('abort', propagateAbort),
  };
}

export function createStallWatchdog({
  timeoutMs,
  platform,
  isStopped,
  onStall,
}: {
  timeoutMs: number;
  platform: 'native' | 'web';
  isStopped: () => boolean;
  onStall: () => void;
}) {
  let timer: TimeoutHandle | null = null;

  const stop = () => {
    if (timer) clearTimeout(timer);
    timer = null;
  };

  const reset = () => {
    stop();
    timer = setTimeout(() => {
      if (!isStopped()) {
        console.warn(`[SmartAmpSse] no event for ${timeoutMs}ms on ${platform} — reconnecting`);
        onStall();
      }
    }, timeoutMs);
  };

  return { reset, stop };
}
